import { TextField, TextFieldProps } from "@mui/material";

type SelectedTextFieldProps = Pick<
	TextFieldProps,
	| "autoComplete"
	| "autoFocus"
	| "error"
	| "helperText"
	| "id"
	| "inputRef"
	| "label"
	| "name"
	| "onChange"
	| "type"
	| "value"
>;

export interface SignUpTextFieldProps extends SelectedTextFieldProps {
	/**
	 * Exposes the `inputProps` property `data-testid`
	 */
	dataTestId: string;
}

export const SignUpTextField = ({
	dataTestId,
	...props
}: SignUpTextFieldProps): JSX.Element => {
	return (
		<TextField
			{...props}
			inputProps={{ "data-testid": dataTestId }}
			fullWidth
			InputLabelProps={{ shrink: true }}
			required
			variant="outlined"
			sx={{
				// Pill-shaped label that always sits neatly above the input
				"& .MuiInputLabel-outlined": {
					position: "static",
					transform: "none",
					textAlign: "left",
					marginBottom: "6px",
					color: "rgba(255, 255, 255, 0.92)",
					"&.MuiInputLabel-shrink": {
						transform: "none",
					},
					"&.Mui-focused": {
						color: "#FFFFFF",
						fontWeight: 600,
					},
					"&.Mui-error": {
						color: "#FFB4AB",
					},
				},
				// Heavily rounded, solid white pill that pops against the blue panel
				"& .MuiOutlinedInput-root": {
					borderRadius: "32px",
					backgroundColor: "#FFFFFF",
					boxShadow: "inset 0 0 0 1px rgba(9, 32, 63, 0.14)",
					transition: "box-shadow 0.2s ease-in-out",
					"&:hover": {
						boxShadow: "inset 0 0 0 1px rgba(9, 32, 63, 0.35)",
					},
					"&.Mui-focused": {
						boxShadow: "inset 0 0 0 2px #2A5EFF",
					},
					"&.Mui-error": {
						boxShadow: "inset 0 0 0 2px #D32F2F",
					},
				},
				"& .MuiOutlinedInput-notchedOutline": {
					border: "none",
				},
				"& .MuiOutlinedInput-input": {
					color: "#0B1C3F",
					paddingTop: "14px",
					paddingBottom: "14px",
				},
				"& .MuiFormHelperText-root": {
					marginLeft: "12px",
					marginTop: "4px",
					"&.Mui-error": {
						color: "#FFB4AB",
					},
				},
			}}
		/>
	);
};
